import { computed, reactive, toRefs } from "vue"

const state = reactive({
    carts: []
})

const cartCount = computed(() => state.carts.length )

function setCartItem(data) {
    Object.assign(state.carts, data)
}

export function useCartStore() {
    return {
        ...toRefs(state),
        cartCount,
        setCartItem
    }
}